<div class="add-widget-buttons">
	<div *ngFor="let wd of stageWidgetDefinitions" class="add-widget-button" (click)="createNewWidget(wd.widgetDefinitionType)" [hidden]="(wd.widgetDefinitionType === 'app' && editorService?.parentEntityType === 'App') || (wd.widgetDefinitionType === 'button' && !rootPermission)">
		<div [attr.data-cy]="'widget-' + ('WIDGET_DEF_' + wd.widgetDefinitionType | uppercase | translate | lowercase)">
			<span [innerHTML]="wd.widgetDefinitionType | widgetIcon" class="widget-icon"></span>
		</div>
		<div class="widget-type">
			{{'WIDGET_DEF_' + wd.widgetDefinitionType | uppercase | translate | uppercase}}
		</div>
	</div>
</div>
